import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type {
  Workflow,
  WorkflowCreate,
  WorkflowFilter,
  WorkflowInstance,
  WorkflowInstanceFilter,
  ApprovalLog,
  ApprovalLogFilter,
} from '../data/workflow';

export function createWorkflowService(client: AxiosInstance) {
  return createCrudService<Workflow, WorkflowCreate, WorkflowFilter>(client,
    "/workflow/WorkflowDefinition",
    "workflowId",
  );
}

export type WorkflowService = CrudService<Workflow, WorkflowCreate, WorkflowFilter>;

export function createWorkflowInstanceService(client: AxiosInstance) {
  return createCrudService<WorkflowInstance, WorkflowInstance, WorkflowInstanceFilter>(client,
    "/workflow/WorkflowInstance",
    "workflowInstanceId",
  );
}

export type WorkflowInstanceService = CrudService<
  WorkflowInstance,
  WorkflowInstance,
  WorkflowInstanceFilter
>;

export function createApprovalLogService(client: AxiosInstance) {
  return createCrudService<ApprovalLog, ApprovalLog, ApprovalLogFilter>(client,
    "/workflow/ApprovalRequest",
    "approvalLogId",
  );
}

export type ApprovalLogService = CrudService<ApprovalLog, ApprovalLog, ApprovalLogFilter>;
